<template>
  <div>
    <p class="text">¿Cuáles son los tipos de grupos?</p>
    <p class="text text--italic text--flex">
      <InfoCircleOutlined /> Por defecto, tus grupos siempre mantendrán un orden. Se ubicarán en la
      parte superior lo grupos de mayor puntaje. En caso de crear más de un grupo de un mismo tipo,
      pordrás ordenarlos manualmente.
    </p>
    <div>
      <p class="text text--small">
        <strong>
          Grupo contacto directo <span class="text text--italic"> (Mayor puntaje)</span
          ><br /> </strong
        >Si se obtuvo un contacto efectivo con el titular de la línea.
      </p>
      <p class="text text--small">
        <strong>
          Grupo contacto indirecto
          <span class="text text--italic"> (Puntaje intermedio)</span><br /> </strong
        >Si se obtuvo contacto con familiares o conocidos del cliente.
      </p>
      <p class="text text--small">
        <strong>
          Grupo no contacto <span class="text text--italic">(Menor puntaje)</span><br /> </strong
        >Si se obtuvo resultados de buzón de voz, apagados o inexistentes.
      </p>
    </div>
  </div>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
  },
});
</script>

<style lang="sass" scoped>
.text
  font-weight: 600
  font-size: 12px
  &--flex
    display: flex
  &--italic
    font-style: italic
    font-weight: 400
    .anticon
      margin: 3px 5px 0 0
  &--small
    color: $gray-7
    margin-left: 17px
    font-weight: normal
</style>
